<template>
  <div class="web-box-all">
    <ext-header select_menu="4"></ext-header>
    <div class="web-home-main">
      <div class="web-home-title">
        <a></a>
        <p>资料库<i></i></p>
        <a></a>
      </div>
    </div>

    <div class="web-home-main">
      <div class="web-news-box">
        <div class="web-news-left">
          <h2>资料库<span>Show</span></h2>
          <p>
            <img src="@/assets/franke-dianqi.png"/>
          </p>
          <ul>
            <li v-for="(vo,index) in list_data" :key="index" :class="[vo.id==select_id ? 'select' : '']">
              <a @click="go_news_show(vo.id)">{{vo.title}}</a>
              <img v-if="vo.id==select_id" src="@/assets/icon/right_3.png" />
            </li>
          </ul>
        </div>
        <div class="web-news-right">
          <div class="web-news-body-main" id="lemon_html">
            <iframe v-if="new_type==3"
            :src="news_url"
            width="100%"
            :height="iframeH"
            frameborder="0"
            scrolling="no"
            ref="iframe"
            ></iframe>
          </div>

          <div class="web-news-body-main" id="lemon_pdf">
             <div v-if="new_type==1" id="web_pdf"></div>
          </div>

          <div class="web-news-body-main" id="lemon_video">
            <div v-if="new_type==2" class="web-news-title">
              <h2>{{news_data.title}}</h2>
              <p>{{news_data.ctime}}</p>
            </div>
            <div v-if="new_type==2" class="web-news-video">
              <ext-video :options="videoOptions"></ext-video>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import ExtVideo from '@/components/video/index'
import $ from 'jquery'
import {getUserId, ajax, Encrypt, Decrypt, webUrl} from '@/utils/extend'
import Pdfh5 from 'pdfh5'
import 'pdfh5/css/pdfh5.css'

export default {
  name: 'news_list',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-video': ExtVideo
  },
  data () {
    return {
      title: '发现',
      select_id: '0',
      web_url: webUrl(),
      new_type: 1,
      list_data: [],
      news_id: '',
      news_data: {
        title: '',
        ctime: '',
        flv_img: '',
        flv_url: ''
      },
      news_url: '',
      iframeH: '',
      pdfUrl: '',
      pdfh5: null,
      videoOptions: {
        width: 740,
        autoplay: 'false', // 自动播放
        controls: true, // 用户可以与之交互的控件
        loop: true, // 视频一结束就重新开始
        muted: false, // 默认情况下将使所有音频静音
        aspectRatio: '16:9', // 显示比率
        fullscreen: {
          options: {navigationUI: 'hide'}
        },
        sources: [
          {
            src: '',
            type: 'video/mp4'
          }
        ]
      }
    }
  },
  created () {
    var that = this
    setTimeout(function () {
      that.news_url = webUrl() + '/store/api/news_html?id=' + that.select_id

      that.pdf_url = that.$route.query.url
    }, 1500)
  },
  mounted () {
    var params = this.$route.query
    var that = this

    if (params.v) {
      this.select_id = Decrypt(params.v)
    } else {
      this.select_id = ''
    }

    this.load_data()

    var flvImg = this.news_data.flv_img
    var flvUrl = this.news_data.flv_url

    let timer = setTimeout(() => {
      var pdfUrl = this.pdfUrl
      var newType = this.new_type
      if (pdfUrl) {
        that.pdfh5 = new Pdfh5('#web_pdf', { pdfurl: pdfUrl, goto: 1 })
      } else if (flvImg && flvUrl) {

      } else {
        if (newType === 3) {
          that.$nextTick(() => { // 必须在页面加载完成之后获取高
            // iframe自适应高
            that.iframeH = that.$refs.iframe.contentWindow.document.documentElement.scrollHeight || that.$refs.iframe.contentWindow.document.body.scrollHeight
          })
        }
      }
    }, 2300)
    // 清除定时器
    this.$once('hook:beforeDestroy', () => {
      clearInterval(timer)
      timer = null
    })
  },
  methods: {
    go_news_show (id) {
      var selectId = this.select_id
      if (selectId !== id) {
        this.$router.push({path: '/news/news_list', query: {v: Encrypt(id)}})
      }
    },
    load_data () {
      var that = this
      ajax({
        url: '/store/home/news_list_json',
        method: 'post',
        data: {
          uid: getUserId(),
          target_id: '2'
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          if (!that.select_id) {
            that.select_id = ret.data['0'].id
            that.go_news_show(ret.data['0'].id)
          }
          that.list_data = ret.data

          that.load_show()
        } else {
          that.list_data = []
        }
      })
    },
    load_show () {
      var id = this.select_id
      var that = this
      ajax({
        url: '/store/home/news_show_json',
        method: 'post',
        data: {
          uid: getUserId(),
          id: id
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          var pdfUrl = ret.data.pdf_url
          that.news_data.title = ret.data.title
          that.news_data.ctime = ret.data.ctime
          that.news_data.flv_img = ret.data.flv_img
          that.news_data.flv_url = ret.data.flv_url

          if (pdfUrl) {
            that.pdfUrl = webUrl() + pdfUrl
            $('#lemon_html').hide()
            $('#lemon_video').hide()
            $('#lemon_pdf').show()
            that.new_type = 1
          } else if (ret.data.flv_img && ret.data.flv_url) {
            $('#lemon_html').hide()
            $('#lemon_pdf').hide()
            $('#lemon_video').show()
            that.new_type = 2
            that.videoOptions.sources[0].src = webUrl() + that.news_data.flv_url
          } else {
            $('#lemon_html').show()
            $('#lemon_pdf').hide()
            $('#lemon_video').hide()
            that.new_type = 3
          }
        }
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-home-title { width:100%; height:50px; position: relative; flex-flow:row; justify-content:center; display: flex; margin-top:15px;}
  .web-home-title a { width:100px; height:10px; background: url('https://parts.franke.cn/static/image/line001.png') repeat-x; margin-top:22px; flex:1;}
  .web-home-title p { width:auto; padding:0px 15px; position: relative; box-sizing: border-box; height:50px; line-height: 50px; font-size:24px; color:#333333; text-align: center; justify-content:center;}
  .web-home-title p i { width:24px; height:1px; border-top:3px solid #d81e06; position: absolute; bottom:0px; left:50%; margin-left:-12px;}
  .web-home-title b { width:80px; cursor: pointer; height:50px; text-align: right; font-weight: normal; line-height:50px; font-size:12px; background: #ffffff; color:#666666; position: absolute; right: 0px; top:0px;}

.web-news-box { width:100%; height:auto; margin-top:15px; flex-wrap:wrap; align-content:flex-start;}
.web-news-left { width:230px; height:auto; margin-right:30px; border:1px solid #dfdfdf;flex-wrap:wrap; align-content:flex-start;}
  .web-news-left h2 { width:100%; height:50px; line-height:50px; position: relative; margin:-1px 0px 0px 0px; padding:0px; border-top:2px solid #d81e06; padding-left:15px; font-size:18px; color:#333333;}
  .web-news-left h2 span { position: absolute; line-height:50px; top:0px; right:15px; font-size:12px; color:#b2b2b2;}
  .web-news-left p { width:100%; height:130px; margin:0px; padding:0px;}
  .web-news-left p img { width:100%; height:130px;}
  .web-news-left ul { width:100%; height:auto; list-style:none; margin:5px 0px 0px 0px; padding:10px 0px;flex-wrap:wrap; align-content:flex-start;}
  .web-news-left ul li { width:100%; height:auto; margin:0px; position: relative; padding:10px 25px 10px 15px; border-left:3px solid #ffffff;}
  .web-news-left ul li:hover { border-left:3px solid #d81e06; background: #fbe1df;}
  .web-news-left ul li.select { border-left:3px solid #d81e06; background: #fbe1df;}
  .web-news-left ul li img { width:18px; height:18px; top:50%; right:5px; margin-top:-9px; position: absolute;}
  .web-news-left ul li a { width:100%; height:auto; cursor: pointer; line-height:20px; font-size:12px; color:#333333; margin:0px; padding:0px;}
.web-news-right { width:740px; height:auto; flex-wrap:wrap; align-content:flex-start;}
  .web-news-title { width:100%; height:80px; border-left:3px solid #d81e06; padding-left:25px; flex-wrap:wrap; align-content:flex-start;}
    .web-news-title h2 { width:100%; height:40px; margin:10px 0px 0px 0px; padding:0px; line-height:40px; font-size:22px; color:#333333;}
    .web-news-title p { width:100%; height:20px; margin:0px; padding:0px; line-height:20px; font-size:12px; color:#cccccc;}
  .web-news-image { width:100%; height:auto; border-left:1px solid #dfdfdf;}
  .web-news-image img { width:100%; height:auto;}
  .web-news-body { width:100%; height:auto; border-left:1px solid #dfdfdf; flex-wrap:wrap; align-content:flex-start; padding:10px 0px 0px 25px;}
  .web-news-body img { width:100%; height:auto;}

.web-news-body-main { width:100%; height: auto; flex-wrap:wrap; align-content:flex-start; display: none;}
  .web-news-video { width:740px; height: 400px; flex-wrap:wrap; }
</style>



// WEBPACK FOOTER //
// src/pages/news/news_list.vue